import { render } from "./InspectionNavbar.vue?vue&type=template&id=52496570&scoped=true"
import script from "./InspectionNavbar.vue?vue&type=script&lang=js"
export * from "./InspectionNavbar.vue?vue&type=script&lang=js"

import "./InspectionNavbar.vue?vue&type=style&index=0&id=52496570&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52496570"]])

export default __exports__